import tagcommander from 'tagcommander';

export default {
  /**
   * Ces evenements sont comptabilis� dans le calcul du bounce rate d'une page
   * A utiliser pour toute action de l'internaute
   * @deprecated utiliser sendEvent
   */
  deprecatedSendEvent: function(eventCategory, eventAction, eventLabel, eventValue) {
    return tagcommander.tc_events_1(this, 'ga_1', {
      Category: eventCategory !== undefined ? eventCategory : null,
      Action: eventAction !== undefined ? eventAction : null,
      Label: eventLabel !== undefined ? eventLabel : null,
      Value: eventValue !== undefined ? eventValue : null
    });
  },
  /**
   * Ces evenements sont comptabilis� dans le calcul du bounce rate d'une page
   * A utiliser pour toute action de l'internaute
   */
  sendEvent: function(eventCategory, eventAction, eventLabel, eventValue) {
    return tagcommander.tc_events_1(this, 'eventGA', {
      categoryGA: eventCategory != null ? eventCategory : '',
      actionGA: eventAction != null ? eventAction : '',
      labelGA: eventLabel != null ? eventLabel : '',
      valueGA: eventValue !== undefined ? eventValue : '0',
      nonInteraction: '0'
    });
  },
  /**
   * Ces evenements ne sont pas comptabilis� dans le calcul du bounce rate d'une page
   * A utiliser pour les �v�nements d'affichage (exemple: un bloc est affich�)
   */
  sendNonInteractiveEvent: function(eventCategory, eventAction, eventLabel, eventValue) {
    return tagcommander.tc_events_1(this, 'eventGA', {
      categoryGA: eventCategory != null ? eventCategory : '',
      actionGA: eventAction != null ? eventAction : '',
      labelGA: eventLabel != null ? eventLabel : '',
      valueGA: eventValue !== undefined ? eventValue : '0',
      nonInteraction: '1'
    });
  }
};
